import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../gd-components/base-component/base-component";

import { isEqual } from 'lodash';
import Classes from 'classnames';

//dnd
import ItemsDragLayer from "./custom-drag-layer";
import ReorderableItem from "./reorderable-item";
import DNDContext from "core/gd/dnd-context";

export default DNDContext(class ReorderableList3 extends BaseComponent {

    static propTypes = {
        headerComponent: PropTypes.object,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                item: PropTypes.any.isRequired,
                component: PropTypes.object.isRequired,
            })
        ),
        itemClassName: PropTypes.string,

        enableJSHover: PropTypes.bool,
        disabled: PropTypes.bool,

        onDragEnd: PropTypes.func,
        dragSourceType: PropTypes.string // any unique string
    };

    static defaultProps = {
        enableJSHover: true
    }

    state = {
        cards: this.props.items
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.items, this.state.cards)){
            this.setState({
                cards: nextProps.items
            });
        }
    }

    moveCard = (dragIndex, hoverIndex) => {
        const cards = this.state.cards.slice();
        const dragCard = cards[dragIndex];

        cards.splice(dragIndex,1); //remove dragged item at dragIndex
        cards.splice(hoverIndex,0,dragCard); //remove no items at hoverIndex and add dragCard at this position

        this.setState({
            cards: cards
        });
    }

    onDragStart = () => {
        this.addClass('drag-started');
    }

    onDragEnd = () => {
        this.removeClass('drag-started');
        if (this.props.onDragEnd) this.props.onDragEnd(this.state.cards.map(c=>c.item));
    }

    render() {
        return (
            <div className={Classes("gd-sortable-list-3", this.props.className)}>
                {this.props.headerComponent}

                {this.state.cards.map((card,key)=>
                    <ReorderableItem key={key}
                                     className={this.props.itemClassName}
                                     index={key}
                                     item={card}
                                     enableJSHover={this.props.enableJSHover}
                                     disableDrag={this.props.disabled}
                                     onDragStart={this.onDragStart}
                                     onDragEnd={this.onDragEnd}
                                     moveCard={this.moveCard}
                                     dragSourceType={this.props.dragSourceType}>
                        {card.component}
                    </ReorderableItem>
                )}

                {this.props.children}

                <ItemsDragLayer dragSourceType={this.props.dragSourceType}
                                parent={this}/>
            </div>
        );
    }
})